
import React from 'react';
import { Button } from '@/components/ui/button';
import { Download, RefreshCw } from 'lucide-react';

interface ReferralUsersActionsProps {
  onRefresh: () => void;
  onExportCSV: () => void;
  isLoading: boolean;
}

const ReferralUsersActions: React.FC<ReferralUsersActionsProps> = ({
  onRefresh,
  onExportCSV,
  isLoading
}) => {
  return (
    <div className="flex space-x-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        disabled={isLoading}
      >
        <RefreshCw className="mr-2 h-4 w-4" />
        Refresh
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onExportCSV}
        disabled={isLoading}
      >
        <Download className="mr-2 h-4 w-4" />
        Export CSV
      </Button>
    </div>
  );
};

export default ReferralUsersActions;
